export default __webpack_public_path__ + "static/media/shape-13.9ca79e8c.svg";